import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Layout from '../components/Layout';
import Container from '../components/Container';
import Button from '../components/Button';
import Input from '../components/Input';

const AccessForm = styled.div`
  max-width: 500px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
`;

const ErrorMessage = styled.div`
  color: #ff5252;
  text-align: center;
  margin-bottom: 1rem;
`;

const SuccessMessage = styled.div`
  color: #4caf50;
  text-align: center;
  margin-bottom: 1rem;
`;

function EbayPage() {
  const [accessId, setAccessId] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const storedAuth = localStorage.getItem('ebayAuth');
    if (storedAuth) {
      const authData = JSON.parse(storedAuth);
      setIsAuthenticated(true);
      setUserName(authData.userName);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('/auth/validate-access', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: 'ebay_user', // This could be dynamic based on your needs
          access_code: accessId,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setIsAuthenticated(true);
        setUserName(data.userName);
        localStorage.setItem('ebayAuth', JSON.stringify({
          userName: data.userName,
          accessId: accessId,
        }));
      } else {
        setError(data.message || 'Invalid access ID');
      }
    } catch (err) {
      setError('An error occurred while validating your access');
    }
  };

  if (isAuthenticated) {
    return (
      <Layout>
        <Container>
          <AccessForm>
            <Title>eBay Dashboard</Title>
            <SuccessMessage>
              Welcome, {userName}! You have successfully authenticated.
            </SuccessMessage>
            <p style={{ textAlign: 'center' }}>HELLO! This is the eBay page content.</p>
            <Button 
              onClick={() => {
                localStorage.removeItem('ebayAuth');
                setIsAuthenticated(false);
                setAccessId('');
              }}
              style={{ marginTop: '1rem' }}
            >
              Logout
            </Button>
          </AccessForm>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container>
        <AccessForm>
          <Title>eBay Access</Title>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <form onSubmit={handleSubmit}>
            <Input
              type="text"
              placeholder="Enter Access ID"
              value={accessId}
              onChange={(e) => setAccessId(e.target.value)}
              required
            />
            <Button type="submit" style={{ width: '100%', marginTop: '1rem' }}>
              Access
            </Button>
          </form>
        </AccessForm>
      </Container>
    </Layout>
  );
}

export default EbayPage; 